import { useEffect, useState } from 'react';
import { AnnouncerModel } from '@nxt-costco-com/forge-components';

export function BannerAnnouncer({ announcerText }: { announcerText?: string }) {
    const [ariaResultsText, setAriaResultsText] = useState<string | undefined>();

    useEffect(() => {
        setAriaResultsText(announcerText);
    }, [announcerText]);

    return (
        <AnnouncerModel
            announcerText={ariaResultsText}
            callback={setAriaResultsText}
            ariaLive="polite"
            announcerTime={5000}
        />
    );
}
